<template>
  <div class="lift-step-five">

    <div class="mb-4">
      <HousseComplexe :form="form" />
    </div>

    <div class="otn-step-two">
      <v-layout>
        <v-switch
          v-model="form.is_attachments_enabled"
          hide-details
          label="Fixations :"
          class="mb-4 title"
        />
      </v-layout>


      <AttachmentsTable
        :config="attachmentsConfig"
        :form="form"
        :dropdowns="dropdowns"
        :disabled="!form.is_attachments_enabled"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HousseComplexe from "../../modules/HousseComplexe.vue";
import { OTN_FORM_CONFIG } from "@/config/forms/otn-config";
import AttachmentsTable from "@/components/forms/advanced/AttachmentsTable.vue";


export default {
  name: "LiftStepFive",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    },
    dropdowns: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      attachmentsConfig: OTN_FORM_CONFIG.steps[0].sections[0].config
    };
  },
  components: {
    HousseComplexe,
    AttachmentsTable
  },
  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getLiftOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style></style>
